export default "__VITE_ASSET__CCkx_zC0__"